import React from 'react'
import CommonFooter from '../../components/CommonFooter/CommonFooter'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'
import { Button, Card } from 'react-bootstrap'

const Consultation = () => {
  return (
    <div>
      <CommonNavbar hide_btn='d-none' show_btn='d-block' />
      <div className='py-5'>
        <div className='container px-md-5'>
          <section className='bg-gray-50 py-12 px-6 md:px-16'>
            <div className='max-w-5xl mx-auto text-left'>
              {/* Heading */}
              <h2 className='text-3xl md:text-4xl font-bold clr_dark_green mb-6'>
                Consultancy Services
              </h2>
              <p className='text-gray-700 mb-10'>
                Farmer’s City offers a comprehensive advisory ecosystem that
                empowers farmers, agri-startups, and rural entrepreneurs with
                expert guidance. Our consultancy blends financial,
                environmental, and technical expertise to maximize productivity
                while ensuring sustainability.
              </p>

              {/* Microfinance */}
              <h3 className='text-2xl font-semibold clr_dark_green mb-2'>
                Microfinance & Lending Services
              </h3>
              <p className='text-gray-700 mb-6'>
                Access to capital is one of the biggest hurdles for farmers and
                agri-entrepreneurs. We provide structured microfinance and
                lending services that connect individuals and groups to
                affordable credit, working capital, and financial institutions.
                Our team also supports loan structuring, repayment planning, and
                financial literacy to foster long-term financial inclusion and
                farm growth.
              </p>

              {/* Soil Management */}
              <h3 className='text-2xl font-semibold clr_dark_green mb-2'>
                Custom Fertility & Soil Management Plans
              </h3>
              <p className='text-gray-700 mb-6'>
                Healthy soil is the backbone of sustainable farming. We design
                customized fertility and soil management plans using soil
                testing, fertility mapping, and crop-specific requirements.
                These plans include recommendations on nutrient application,
                organic amendments, water management, and soil regeneration,
                ensuring improved yields and long-term soil health.
              </p>

              {/* Environmental Consulting */}
              <h3 className='text-2xl font-semibold clr_dark_green mb-2'>
                Environmental Consulting & Sustainability Guidance
              </h3>
              <p className='text-gray-700 mb-6'>
                Agriculture is deeply connected with the environment. Our
                experts provide sustainability consulting that helps farmers
                adopt eco-friendly practices, including precision irrigation,
                renewable energy integration, biodiversity protection, and waste
                management. We aim to ensure farms are not only productive but
                also climate-resilient and environmentally responsible.
              </p>

              {/* Government Schemes */}
              <h3 className='text-2xl font-semibold clr_dark_green mb-2'>
                Government Scheme Navigation Assistance
              </h3>
              <p className='text-gray-700 mb-6'>
                Many farmers lose out on valuable benefits due to the complexity
                of government schemes. Our consultancy simplifies access to
                subsidies, crop insurance, agri-infrastructure grants, and
                welfare programs. We assist with applications, documentation,
                and compliance to ensure farmers and agri-startups can fully
                leverage state and central government initiatives.
              </p>

              {/* Contact Info */}
              <h3 className='text-2xl font-semibold clr_dark_green mb-2 mt-10'>
                Get in Touch
              </h3>
              <p className='text-gray-700'>
                Email:{' '}
                <a
                  href='mailto:info@farmerscity.in'
                  className='clr_dark_green font-medium'
                >
                  info@farmerscity.in
                </a>
              </p>
              <p className='text-gray-700'>
                Phone:{' '}
                <a
                  href='tel:+91987654321'
                  className='clr_dark_green font-medium'
                >
                  +91-0987654321
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
      <CommonFooter />
    </div>
  )
}

export default Consultation
